<template>
    <div class="selectCustomer">
        <div class="screenSpanBox1">
            <search-bar v-model="value" :showBtnNow="true" @keyup.enter.native="toSearch" @btnClick="btnClick" placeholder="搜索"></search-bar>
        </div>
        <div class="scrollBox">
            <scroll v-if="!loading" class="wrapper" ref="scroll" :pullDownRefresh="pullDownRefreshObj" :pullUpLoad="pullUpLoadObj" :startY="parseInt(startY)" @pullingDown="onPullingDown" @pullingUp="onPullingUp">
                <div class="moduleCodePage">
                    <custListView :listData="listData" :countNum="page.total" :listLabels="listLabels" :personnelTable="personnelTable" :sysBoxValue="sysBoxValue" :isMailSeach="true"></custListView>
                </div>
            </scroll>
            <loading-new :loading="loading"></loading-new>
        </div>
    </div>
</template>
<script>
import SearchBar from '@/page/Document/Vue/SearchBar/index'
import custListView from '../../../Client/CustPublic/custListView/index.vue'
import Scroll from '@/components/Scroll/index'
import loadingNew from '../../../Client/CustPublic/LoadingVue/index.vue'
export default {
    name: 'selectCustomer',
    props: {},
    data() {
        return {
            pullDownRefresh: true,
            pullDownRefreshThreshold: 60,
            pullDownRefreshStop: 60,
            pullUpLoad: true,
            pullUpLoadThreshold: 0,
            pullUpLoadMoreTxt: '加载更多',
            pullUpLoadNoMoreTxt: '没有更多数据了',
            startY: 0,
            scrollToX: 0,
            scrollToY: -200,
            scrollToTime: 700,
            scrollToEasing: 'bounce',
            scrollToEasingOptions: ['bounce', 'swipe', 'swipeBounce'],

            value: '',
            sysBoxValue: [],
            listLabels: [],
            personnelTable: [],
            listData: [],
            page: {
                total: 0,
                from: 0,
                size: 10
            },
            loading: true,
            sort: 'createDate'
        }
    },
    computed: {
        pullDownRefreshObj: function () {
            return this.pullDownRefresh ? {
                threshold: parseInt(this.pullDownRefreshThreshold),
                stop: parseInt(this.pullDownRefreshStop)
            } : false
        },
        pullUpLoadObj: function () {
            return this.pullUpLoad ? {
                threshold: parseInt(this.pullUpLoadThreshold),
                txt: { more: this.pullUpLoadMoreTxt, noMore: this.pullUpLoadNoMoreTxt }
            } : false
        }
    },
    components: {
        'search-bar': SearchBar,
        'custListView': custListView,
        'Scroll': Scroll,
        'loading-new': loadingNew
    },
    created() {

    },
    mounted() {
        this.pageUrl = this.$route.path
        this.unit()
        this.pageInit()
    },
    methods: {
        async toSearch() {
            let obj = {
                keywords: this.value
            }
            this.listData = await this.getListData(obj)
        },
        btnClick() {
        },
        pageInit() {
            if (this.$route.path == '/mail/selectCustomer') {
                this.setHeaderTitle('选择客户')
                this.Global.utils.rightMenu.clearMenu()
            }
            // send back  联系人回退
            // enter  选择联系人
        },
        unit(loading) {
            if (!loading) {
                this.loading = true
            }
            var p1 = new Promise((resolve, reject) => {
                let data = {
                    moduleCode: 'BF001',
                    order: 'desc',
                    from: loading ? 0 : this.page.from,
                    size: loading ? this.page.from + this.page.size : this.page.size,
                    sort: this.sort,
                    searchType: 'list'
                }
                if (JSON.stringify(this.routParameters) != '{}') {
                    this.otherObj = {}
                    this.otherObj = Object.assign(this.otherObj, this.routParameters)
                    data = Object.assign(data, this.otherObj)
                    this.set_routParameters({})
                } else {
                    data = Object.assign(data, this.otherObj)
                }
                this.axios.get(this.Global.config.apiBaseURL + this.Global.api.v2.document_generalOperate_get, { params: data }).then((res) => {
                    if (res.data.code.toString() === this.Global.config.RES_OK) {
                        resolve(res.data.data.list)
                        this.page.total = res.data.data.totalNum
                    } else {
                        if (!loading) {
                            this.loading = false
                        }
                        this.$toast.fail(res.data.msg)
                    }
                }, (res) => {
                    if (!loading) {
                        this.loading = false
                    }
                    this.$toast.fail(this.Global.config.errorTitle)
                })
            })
            var p2 = new Promise((resolve, reject) => {
                let data = {
                    dataType: 'contact',
                    funType: 'all'
                }
                this.axios.get(this.Global.config.apiBaseURL + this.Global.api.v2.accountDropList_get, { params: data }).then((res) => {
                    if (res.data.code.toString() === this.Global.config.RES_OK) {
                        resolve(res.data.data)
                    } else {
                        if (!loading) {
                            this.loading = false
                        }
                        this.$toast.fail(res.data.msg)
                    }
                }, (res) => {
                    if (!loading) {
                        this.loading = false
                    }
                    this.$toast.fail(this.Global.config.errorTitle)
                })
            })
            var p3 = new Promise((resolve, reject) => {
                this.axios.get(this.Global.config.apiBaseURL + this.Global.api.v2.label_get, { params: { searchType: 'list', moduleCode: 'BF001' } }).then((res) => {
                    if (res.data.code.toString() === this.Global.config.RES_OK) {
                        resolve(res.data.data)
                    } else {
                        if (!loading) {
                            this.loading = false
                        }
                        this.$toast.fail(res.data.msg)
                    }
                }, (res) => {
                    if (!loading) {
                        this.loading = false
                    }
                    this.$toast.fail(this.Global.config.errorTitle)
                })
            })
            Promise.all([p1, p2, p3]).then((results) => {
                this.listLabels = results[2]
                this.personnelTable = results[1]
                this.listData = results[0]
                if (!loading) {
                    this.loading = false
                }
            })
        },
        async getListData(obj) {
            let data = {
                moduleCode: 'BF001',
                order: 'desc',
                size: this.page.size,
                sort: this.sort,
                searchType: 'list'
            }
            if (obj) {
                data = Object.assign(data, obj)
                this.otherObj = obj
                this.page.from = 0
            } else {
                data = Object.assign(data, this.otherObj)
            }
            data.from = this.page.from
            let res = await this.axios.get(this.Global.config.apiBaseURL + this.Global.api.v2.document_generalOperate_get, { params: data })
            if (res.data.code.toString() === this.Global.config.RES_OK) {
                this.page.total = res.data.data.totalNum
                return res.data.data.list
            } else {
                this.$toast.fail(res.data.msg)
                return []
            }
        },
        async onPullingDown() {
            this.page.from = 0
            this.checkedItems = []
            this.listData = await this.getListData()
            this.$nextTick(() => {
                this.$refs.scroll.forceUpdate()
            })
        },
        async onPullingUp() {
            if (this.listData.length >= this.page.total) {
                this.$refs.scroll.forceUpdate(false)
                return
            }
            if (this.listData.length < this.page.total) {
                this.page.from += 10
                let listData = await this.getListData()
                this.listData = this.listData.concat(listData)
                this.$nextTick(() => {
                    if (this.listData.length >= this.page.total) {
                        this.$refs.scroll.forceUpdate(false)
                    } else {
                        this.$refs.scroll.forceUpdate(true)
                    }
                })
            }
        }

    },
    watch: {
        $route(to, form) {
            this.pageInit()
        },
        pullDownRefreshObj: {
            handler(val) {
                const scroll = this.$refs.scroll.scroll
                if (val) {
                    scroll.openPullDown()
                } else {
                    scroll.closePullDown()
                }
            },
            deep: true
        },
        pullUpLoadObj: {
            handler(val) {
                const scroll = this.$refs.scroll.scroll
                if (val) {
                    scroll.openPullUp()
                } else {
                    scroll.closePullUp()
                }
            },
            deep: true
        },
        startY() {
            // this.rebuildScroll()
        }
    }
}
</script>
<style lang="less" scoped>
@import "./zh-cn.less";
@import "./en.less";
</style>
